export const generateProducts = (count = 100) => {
  const products = []
  const categories = ['electronics', 'fashion', 'home', 'beauty', 'toys', 'sports', 'machinery', 'packaging']
  
  const suppliers = [
    { name: 'Shenzhen Tech Pro', years: 5, rating: 4.8 },
    { name: 'Guangzhou Fashion Co', years: 8, rating: 4.6 },
    { name: 'Yiwu Trading Ltd', years: 3, rating: 4.2 },
    { name: 'Ningbo Tools Factory', years: 12, rating: 4.9 },
    { name: 'Shanghai Industrial Group', years: 15, rating: 4.7 }
  ]

  const productTypes = {
    electronics: ['Smartphone', 'Wireless Earbuds', 'Smart Watch', 'USB Cable', 'Power Bank', 'Tablet Case'],
    fashion: ['T-Shirt', 'Jeans', 'Summer Dress', 'Sneakers', 'Hoodie', 'Handbag'],
    home: ['LED Lamp', 'Kitchen Knife Set', 'Bed Sheets', 'Storage Box', 'Wall Decor', 'Garden Tool'],
    beauty: ['Makeup Brush Set', 'Face Cream', 'Lipstick', 'Hair Dryer', 'Nail Polish', 'Perfume Bottle'],
    toys: ['RC Car', 'Building Blocks', 'Plush Bear', 'Puzzle', 'Drone', 'Action Figure'],
    sports: ['Yoga Mat', 'Dumbbell Set', 'Running Shoes', 'Bicycle Light', 'Tennis Racket', 'Camping Tent'],
    machinery: ['CNC Part', 'Industrial Motor', 'Laser Cutter', 'Packaging Machine', 'Drill Bit', 'Bearing'],
    packaging: ['Cardboard Box', 'Gift Bag', 'Bubble Mailer', 'Custom Sticker', 'Glass Jar', 'Plastic Bottle']
  }

  const categoryImages = {
    electronics: [
      'https://images.unsplash.com/photo-1511384039668-7e67455ab52f?w=400&h=400&fit=crop',
      'https://images.unsplash.com/photo-1546868871-7041f2a55e12?w=400&h=400&fit=crop',
      'https://images.unsplash.com/photo-1523275335684-37898b6baf30?w=400&h=400&fit=crop'
    ],
    fashion: [
      'https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=400&h=400&fit=crop',
      'https://images.unsplash.com/photo-1542291026-7eec264c27ff?w=400&h=400&fit=crop',
      'https://images.unsplash.com/photo-1591561954557-26941169b49e?w=400&h=400&fit=crop'
    ],
    home: [
      'https://images.unsplash.com/photo-1505693416388-b0346efee539?w=400&h=400&fit=crop',
      'https://images.unsplash.com/photo-1583847661867-7ced4da44f61?w=400&h=400&fit=crop',
      'https://images.unsplash.com/photo-1513694203232-719a280e022f?w=400&h=400&fit=crop'
    ],
    default: 'https://images.unsplash.com/photo-1553456558-aff63285bdd1?w=400&h=400&fit=crop'
  }

  for (let i = 1; i <= count; i++) {
    const category = categories[Math.floor(Math.random() * categories.length)]
    const supplier = suppliers[Math.floor(Math.random() * suppliers.length)]
    const type = productTypes[category][Math.floor(Math.random() * productTypes[category].length)]
    const price = (Math.random() * 100 + 1).toFixed(2)
    
    const imgs = categoryImages[category] || [categoryImages.default]
    const image = imgs[Math.floor(Math.random() * imgs.length)]

    products.push({
      id: i,
      name: {
        en: `Wholesale ${type} - High Quality ${category} Product`,
        de: `Großhandel ${type} - Hochwertiges ${category} Produkt`,
        fr: `Vente en gros ${type} - Produit ${category} de haute qualité`
      },
      description: {
        en: `Premium quality ${type.toLowerCase()} directly from factory. Perfect for retail or personal use. Bulk discounts available.`,
        de: `Erstklassige Qualität ${type.toLowerCase()} direkt ab Werk. Perfekt für Einzelhandel oder Eigenbedarf. Mengenrabatte verfügbar.`,
        fr: `Qualité supérieure ${type.toLowerCase()} directement de l'usine. Parfait pour la vente au détail ou l'usage personnel. Remises sur quantité disponibles.`
      },
      price: parseFloat(price),
      originalPrice: parseFloat((price * 1.25).toFixed(2)),
      category: category,
      image: image,
      images: [image, image, image],
      rating: (Math.random() * 1.5 + 3.5).toFixed(1),
      reviews: Math.floor(Math.random() * 500) + 10,
      minOrderQuantity: Math.floor(Math.random() * 20) + 1,
      inStock: Math.random() > 0.1,
      tradeAssurance: Math.random() > 0.3,
      verified: Math.random() > 0.4,
      supplier: supplier,
      specifications: {
        Material: 'Premium Grade',
        Origin: 'China',
        MOQ: 'Negotiable',
        'Lead Time': '7-15 days',
        Certification: 'CE, RoHS'
      },
      createdAt: new Date(Date.now() - Math.floor(Math.random() * 90 * 24 * 60 * 60 * 1000)).toISOString()
    })
  }

  return products
}

export function searchProductsLocal(products, query, filters = {}, lang = 'en') {
  let results = [...products]

  const getLocalized = (obj) => {
    if (!obj) return ''
    if (typeof obj === 'string') return obj
    return obj[lang] || obj['en'] || obj['de'] || ''
  }

  // Text search
  if (query && query !== 'alle' && query !== 'all') {
    const term = query.toLowerCase()
    results = results.filter(p => {
      const name = getLocalized(p.name)
      const description = getLocalized(p.description)
      return (
        name.toLowerCase().includes(term) ||
        description.toLowerCase().includes(term) ||
        p.category.toLowerCase().includes(term)
      )
    })
  }

  // Category filter
  if (filters.category && filters.category !== 'all') {
    results = results.filter(p => p.category === filters.category)
  }

  // Price range filter
  if (filters.priceRange) {
    const [minPrice, maxPrice] = filters.priceRange
    results = results.filter(p => p.price >= (minPrice || 0) && p.price <= (maxPrice || 100000))
  }

  // Rating filter
  if (filters.minRating) {
    results = results.filter(p => parseFloat(p.rating) >= parseFloat(filters.minRating))
  }

  // Stock filter
  if (filters.inStock) {
    results = results.filter(p => p.inStock)
  }

  // Trade Assurance filter
  if (filters.tradeAssurance) {
    results = results.filter(p => p.tradeAssurance)
  }

  // Verified filter
  if (filters.verified) {
    results = results.filter(p => p.verified)
  }

  // MOQ filter
  if (filters.maxMoq) {
    results = results.filter(p => p.minOrderQuantity <= filters.maxMoq)
  }

  // Sort results
  if (filters.sortBy) {
    switch (filters.sortBy) {
      case 'price_asc':
        results.sort((a, b) => a.price - b.price)
        break
      case 'price_desc':
        results.sort((a, b) => b.price - a.price)
        break
      case 'rating':
        results.sort((a, b) => b.rating - a.rating)
        break
      case 'newest':
        results.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
        break
      case 'relevance':
      default:
        break
    }
  }

  return results
}

export function paginateProducts(products, page = 1, limit = 24) {
  const startIndex = (page - 1) * limit
  const endIndex = startIndex + limit
  const paginatedItems = products.slice(startIndex, endIndex)

  return {
    products: paginatedItems,
    total: products.length,
    page: page,
    totalPages: Math.ceil(products.length / limit),
    hasMore: endIndex < products.length
  }
}